module.exports = __webpack_public_path__ + "media/partners-logos/1_Percent_Logo_@2x-e1a18dc0.png";